import React, { useEffect } from 'react';
import { withAuth } from '@cdk-prod/fortellis-auth-context';
import { withEntityContext } from '@cdk-prod/fortellis-entity-context';
import { loadWalkMeScript, updateFortellisWalkMeData } from './walkMeHelper';

const WalkMe = ({ auth, entityContext }) => {
  useEffect(() => {
    if (process.env.REACT_APP_WALKME_SRC)
      loadWalkMeScript({ walkMeSrc: process.env.REACT_APP_WALKME_SRC });
  }, []);

  useEffect(() => {
    updateFortellisWalkMeData({
      userData: auth.userData,
      entityData: entityContext.entity
    });
  }, [auth.userData?.email, entityContext.entity]);

  return null;
};

export default withAuth(withEntityContext(WalkMe));
